import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const slice = createSlice({
  name: '$importedGiftCardRegex',
  initialState,
  reducers: {
    setImportedGiftCardRegex(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
});

export const { setImportedGiftCardRegex } = slice.actions;
export default slice.reducer;
